import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BaseViewElement } from '../base-view-element';
import { PropertySet } from '../../../core/model/helper-models/property-set.model';
import { Property } from '../../../core/model/helper-models/property.model';
import { MonitoringLevel } from '../../../core/model/MonitoringLevels.enum';

@Component({
  selector: 'app-prtlrbt-status',
  templateUrl: './prtlrbt-status.component.html',
    styleUrls: ['./prtlrbt-status.component.scss',
        './../card.scss'],
    standalone: false
})
export class PrtlrbtStatusComponent extends BaseViewElement implements OnChanges
{

    operationModes = new Map<number, string>([[0, 'keine'], [1, 'Hand'], [2, 'Halbautomatik'], [3, 'Automatik'], [4, 'Sammelstörung']]);

    @Input() Status: PropertySet;
    @Input() Maintenance: PropertySet;

    OperatingMode: number;
    Automatic: Property<any>;
    AutmaticDisturbed: Property<any>;
    AutoActive: Property<any>;
    AutoJobActive: Property<any>;
    CollectivFault: Property<any>;
    Manual: Property<any>;

    OperatingHours: Property<any>;

    constructor()
    {
        super('prtlrbt-status');
    }


    onResize(result: any)
    {
        this.childResizeEvent.emit();
    }

    ngOnChanges(changes: SimpleChanges): void
    {
        if (this.Status != null) {
            if (this.Status.properties.get('AUTOMATIC').TimeseriesData.currentDatapoint.value === 1){
                this.OperatingMode =  3;
            }
            else if (this.Status.properties.get('MANUAL').TimeseriesData.currentDatapoint.value === 1)
            {
                this.OperatingMode =  1;
            }
            else if (this.Status.properties.get('AUTOMATIC_DISTURBED').TimeseriesData.currentDatapoint.value === 1)
            {
                this.OperatingMode =  2;
            }
            else if (this.Status.properties.get('COLLECTIVE_FAULT').TimeseriesData.currentDatapoint.value === 1)
            {
                this.OperatingMode =  4;
            }

            this.Automatic = this.Status.properties.get('AUTOMATIC');
            this.AutmaticDisturbed = this.Status.properties.get('AUTOMATIC_DISTURBED');
            this.AutoActive = this.Status.properties.get('AUTO_ACTIVE');
            this.AutoJobActive = this.Status.properties.get('AUTO_JOB_ACTIVE');
            this.CollectivFault = this.Status.properties.get('COLLECTIVE_FAULT');
            this.Manual = this.Status.properties.get('MANUAL');
        }

        if (this.Maintenance != null) {
            this.OperatingHours = this.Maintenance.properties.get('OPERATING_HOURS');
        }
    }
}
